import { queryOptions } from '@tanstack/react-query';
import { axiosGet } from '../utils/api';

export const getAdminAiLogs = () =>
  queryOptions({
    queryKey: ['/admin/ai-logs'],
    queryFn: async () => {
      const res = await axiosGet('/admin/ai-logs');
      return res.data;
    },
  });

export const getAdminAiLog = (id) =>
  queryOptions({
    queryKey: ['/admin/ai-logs', id],
    queryFn: async () => {
      const res = await axiosGet(`/admin/ai-logs/${id}`);
      return res.data;
    },
  });
